import { observer } from 'mobx-react-lite';
import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';
import { useTranslation } from 'next-i18next';
import { useEffect } from 'react';
import { LOGIN_PAGE_TYPES } from '@features/loginPage/const';
import { TLoginView } from '@features/loginPage/typescript';
import Login from '@features/loginPage/components/Login/Login';
type PropsType = {
  loginReferer: string;
  showPanel: boolean;
};
const LoginPage = ({
  loginReferer,
  showPanel
}: PropsType) => {
  const router = useRouter();
  const {
    query
  } = router;
  const {
    t
  } = useTranslation(['user', 'common']);

  // Jeśli użytkownik wraca z błędu logowania i nie ma parametru type, ale był na checkout,
  // przekieruj na /login?type=checkout
  useEffect(() => {
    if (typeof window !== 'undefined' && !query.type && query.error) {
      const loginType = sessionStorage.getItem('loginType');
      if (loginType === 'checkout') {
        sessionStorage.removeItem('loginType');
        router.replace({
          pathname: router.pathname,
          query: {
            ...query,
            type: 'checkout'
          }
        });
        return;
      }
    }
  }, [query, router]);
  const viewType: TLoginView = typeof query.type === 'string' && LOGIN_PAGE_TYPES[query.type] ? LOGIN_PAGE_TYPES[query.type] : LOGIN_PAGE_TYPES.general;
  return <>
      <NextSeo title={t(viewType.headerTitle)} />
      <Login loginReferer={loginReferer} showPanel={showPanel} viewType={viewType} />
    </>;
};
export default observer(LoginPage);